import { render, staticRenderFns } from "./PaymentChannelSetModal.vue?vue&type=template&id=26c8f050"
import script from "./PaymentChannelSetModal.vue?vue&type=script&lang=js"
export * from "./PaymentChannelSetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports